import React from 'react';
import { SectionLayout } from 'components/Sections/SectionLayout';
import Text from 'components/Core/Text';
import { Container } from './styles';

const ContentBlockContainer = ({
  backgroundColor = 'White',
  heading,
  subhead,
  children,
  anchorId,
}) => {
  const centerContainedStyles = { maxWidth: '840px', marginLeft: 'auto', marginRight: 'auto' };

  return (
    <SectionLayout backgroundColor={backgroundColor} style={{ textAlign: 'center' }} id={anchorId}>
      <Container>
        {heading && (
          <Text
            type="h2"
            color={backgroundColor !== 'White' ? 'white' : null}
            style={centerContainedStyles}
          >
            {heading}
          </Text>
        )}
        {subhead && (
          <Text
            type="p"
            fontSize="normal"
            color={backgroundColor !== 'White' && 'white'}
            style={centerContainedStyles}
          >
            {subhead.subhead}
          </Text>
        )}
        <div className="content-block-container--child" style={centerContainedStyles}>
          {children}
        </div>
      </Container>
    </SectionLayout>
  );
};

export default ContentBlockContainer;
